import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-funcionamento-direita',
  templateUrl: './funcionamento-direita.component.html',
  styleUrls: ['./funcionamento-direita.component.scss']
})

export class FuncionamentoDireitaComponent implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
